import React from 'react';
import BestTimeToPostTab from '../shared/BestTimeToPostTab';
import { INSTAGRAM } from '../../../config/constants';

const InstagramBestTimeToPostTab: React.FC = () => {
  return (
    <BestTimeToPostTab platforms={[INSTAGRAM]} />
  );
};

export default InstagramBestTimeToPostTab;